export default{
    
  install(Vue, options) {
        //时间戳转换成字符串时间
        Vue.prototype.$formatTime = e => {
            let time = e ? new Date(e) : new Date();
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let date = time.getDate();
            let hour = time.getHours();
            let min = time.getMinutes();
            let sec = time.getSeconds();
    
            return `${year}/${month > 9 ? month : "0" + month}/${
            date > 9 ? date : "0" + date
            } ${hour > 9 ? hour : "0" + hour}:${min > 9 ? min : "0" + min}:${
            sec > 9 ? sec : "0" + sec
            }`;
        };

        //计算时间，多久之前
        Vue.prototype.$calcTime = time => {
            let difTime = (Date.now() - time)/1000
            let cYear = new Date(time-0).getFullYear()
            let cMonth = (new Date(time-0).getMonth() + 1) > 9 ? (new Date(time-0).getMonth() + 1) : '0' + (new Date(time-0).getMonth() + 1)
            let cDate = new Date(time-0).getDate() > 9 ? new Date(time-0).getDate() : '0' + new Date(time-0).getDate()
            let thisYear = new Date().getFullYear();
            if(cYear < thisYear){
                return cYear + "-" + cMonth + "-" + cDate
            }else{
                if(difTime < 60) {
                    return difTime = '刚刚'
                }else if(difTime<3600 && difTime >= 60){
                    return difTime = Math.floor(difTime/60) + '分钟前'
                }else if(difTime>=3600 && difTime < 86400){
                    return difTime = Math.floor(difTime/3600) + '小时前'
                }else{
                    return cMonth + "-" + cDate
                }
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/utils/common.js